import React, { useState, useEffect, useRef } from 'react'
import icon from '../icons.svg'; 

function Menu({children,data,stl,left,bottom}){
    const [Opened, setOpened] = useState(false)
    const [Parent, setParent] = useState(0)
    const node = useRef(null)
    const [currX, setcurrX] = useState(0)

    useEffect(()=>{
        const listener = (event) =>{
            if (node.current && event.target && node.current.contains(event.target)) return
            setOpened(false)
            } 
        if (Opened) document.addEventListener("mousedown", listener)
        return () => {document.removeEventListener("mousedown", listener)}
    })

    function OpenHide(e){
        if(e.target.className==='listfolder') return
        let c = e.target.getBoundingClientRect()
        setcurrX(c.top+c.height+4)
        if(Opened) setOpened(false)
        else if(!Opened) setOpened(true)
    }
    function menuClick(act){
        //console.log('menuClick')
        act()
    }
    function folderClick(id){
        //console.log('folderClick')
        if(Parent===id) setParent(0)
        else setParent(id)
    }

    // eslint-disable-next-line
    const List=data.map((col,idx)=>{
        let visible=0
        if (!col.parent) visible=1
        if (col.disabled) visible=3
        if (col.parent===Parent) visible=2
        if (col.isFolder && col.id===Parent) return(<div className='listfolder' tabIndex='0' key={idx} onClick={(e)=>{folderClick(col.id)}} onKeyUp={(e)=>{if(e.key === 'Enter') folderClick(col.id)}}><img src={icon+(col.icon||'#empty')} className='menu_img' style={{marginLeft:'0'}} alt='' /> {col.name}<div>«</div></div>)
        else if (col.isFolder) return(<div className='listfolder' tabIndex='0' key={idx} onClick={(e)=>{folderClick(col.id)}} onKeyUp={(e)=>{if(e.key === 'Enter') folderClick(col.id)}}><img src={icon+(col.icon||'#empty')} className='menu_img' style={{marginLeft:'0'}} alt='' /> {col.name}<div>»</div></div>)
        else if (visible===1) return(<div className='listitem' tabIndex='0' key={idx} onClick={()=>{menuClick(col.action)}} onKeyUp={(e)=>{if(e.key === 'Enter') menuClick(col.action)}}><img src={icon+(col.icon||'#empty')} className='menu_img' style={{marginLeft:'0'}} alt='' /> {col.name}</div>)
        else if (visible===2) return(<div className='listitem' tabIndex='0' key={idx} onClick={()=>{menuClick(col.action)}} onKeyUp={(e)=>{if(e.key === 'Enter') menuClick(col.action)}}><img src={icon+'#empty'} className='toolBarIcon' style={{marginLeft:'0'}} alt='' /><img src={icon+(col.icon||'#empty')} className='menu_img' style={{verticalAlign:'middle'}} alt='' /> {col.name}</div>)
        else if (visible===3) return(<div className='listitem_disabled' key={idx}>{col.name}</div>)
            //else return(<div className='listitem' tabIndex='0' key={idx} onClick={()=>{col.action()}} onKeyUp={(e)=>{if(e.key === 'Enter') col.action()}}><img src={icon+(col.icon||'#empty')} className='toolBarIcon' style={{verticalAlign:'middle'}} alt='' /> {col.name}</div>)

    })

    let Content=''
    if (Opened) {
        let style2={position:'absolute',overflow:'auto',whiteSpace:'nowrap',fontWeight:'normal',fontSize:'unset'}
        if(left) style2.left=0
        else style2.right=0
        if(bottom) style2.bottom='calc(100% + 2px)'
        else style2.top='calc(100% + 2px)'
        if(!bottom && currX) style2.maxHeight='calc(100vh - '+currX+'px)'
        Content=<div className='list' style={style2}>{List}</div>
    }

    let style1={position:'relative', height:'100%',outline:'none'}
    if(stl) style1={...style1,...stl}

    return (
        <div ref={node}  tabIndex='0' style={style1} onClick={OpenHide} onKeyUp={(e)=>{if(e.key === 'Enter') OpenHide(e)}}>   
            {children}
            {Content}
        </div>
    )
}

export default Menu